export default class DlComponent extends HTMLElement {

    /**
     * Lorsque le composant est connectéé au DOM
     */
    connectedCallback () {

        // Element principal du formulaire
        this.target      = this.querySelector(this.getAttribute('data-target')); // Récupération du formulaire
        this.serialInput = this.target.querySelector('input[data-name="input-serial"]');
        this.vCodeInput  = this.target.querySelector('input[data-name="input-vcode"]');
        this.language    = this.target.querySelector('input[data-name="input-language"]')
        this.message     = this.target.querySelector('div[data-name="message"]')

        // Boutons d'action pour la suite des téléchargement
        this.buttonLastVersion = this.querySelector(this.getAttribute('data-target-button-last-version'))
        this.buttonOtherVersion = this.querySelector(this.getAttribute('data-target-button-other-version'))

        // Element contenant les erreurs / messages
        this.invalidSerial = this.querySelector(this.getAttribute('data-target-invalid-serial'))
        this.invalidVCode = this.querySelector(this.getAttribute('data-target-invalid-vcode'))
        this.noDownload = this.querySelector(this.getAttribute('data-target-no-download'))

        // Texte par défaut à enregistrer sur les boutons
        this.text = {
            "lastVersionDefaultText": this.buttonLastVersion.value,
            "lastVersionPrefix": this.getAttribute('data-dwn-prefix')
                ? this.getAttribute('data-dwn-prefix')
                : "Télécharger la version",
            "wdmsgSup280": this.getAttribute('data-wdmsg-sup-280')
                ? this.getAttribute('data-wdmsg-sup-280')
                : `À partir de la version 2024, il est inutile de télécharger l'installation de WDMSG.
                    WDMSG est directement intégré dans les installations du produit WINDEV, WEBDEV et WINDEV MOBILE.`
        }

        if(this.serialInput.value !== "" && this.vCodeInput.value !== "") {
            this.dispatch()
        }

        // Event listener de change des inputs
        this.serialInput.addEventListener('input', _.debounce(() => this.dispatch(), 250))
        this.vCodeInput.addEventListener('input', _.debounce(() => this.dispatch(), 250))

        // Event listener sur le bouton autre version
        this.buttonOtherVersion.addEventListener('click', (e) => {
            e.preventDefault()
            this.handleButtonOtherVersion();
        })
    }

    /*
     * Déclenche le téléchargement de la dernière version du produit
     */
    handleButtonOtherVersion () {
        this.target.action = window.location.href
        this.target.submit()
    }

    /**
     * - Déclenche l'appel Ajax pour récupérer les information sur le produit
     * - Met à jour le texte du bouton de téléchargement de la dernière version
     * - Active ou désactive les boutons de téléchargement
     */
    async dispatch () {

        try {

            // Par défaut on désactive les boutons et masques les erreurs
            this.disableButtons();
            this.invalidSerial.style.display = "none";
            this.invalidVCode.style.display = "none";
            this.noDownload.style.display = "none";
            this.message.style.display = "none";

            if(this.serialInput.value !== "" && this.vCodeInput !== "") {

                const response = await this.ajaxGetProductInfo()
                if(response) {
                    const hasProduct = response.hasOwnProperty('product')
                    const isDisabled = response.hasOwnProperty('disabled') && response.disabled === true

                    if(hasProduct) {
                        // Si le produit est désactivé par exemple à partir d'une certaine version
                        // WDMSG est directement fourni dans les installations de WINDEV, WEBDEV et WINDEV MOBILE
                        if(isDisabled) {
                            this.buttonLastVersion.style.display = "none";
                            this.message.innerHTML = this.text[response.message];
                            this.message.style.display = "block";
                        } else {
                            // Sinon, on affiche le bouton de téléchargement de la dernière version disponible
                            this.buttonLastVersion.style.display = "block";
                            this.buttonLastVersion.value = response.product.version
                                ? this.text.lastVersionPrefix + " " + response.product.name
                                : this.text.lastVersionDefaultText;
                        }

                        this.toggleButtons(
                            response.product.version,
                            this.vCodeInput.value,
                            this.enableButtons.bind(this),
                            this.disableButtons.bind(this)
                        );

                    }
                    else if(response.hasOwnProperty('errors')) {
                        // Si une erreur sur le serial, ou sur le code d'activation est retourné par le webservice
                        // Alors affiche l'erreur à l'utilisateur
                        if (response.errors.hasOwnProperty('serial')) {
                            this.invalidSerial.style.display = "block";
                        } else if (response.errors.hasOwnProperty('vcode')) {
                            this.invalidVCode.style.display = "block";
                        }
                    }
                    else if (response.hasOwnProperty('error') && response.error === 'no_download') {
                        // Si une erreur de type 'no_download' est retournée par le webservice
                        // On affiche qu'il n'y a pas de téléchargement pour cette version
                        this.noDownload.style.display = "block";
                    }
                }

            }


        } catch (e) {
            // En cas d'erreur on désactive les boutons
            this.disableButtons()
            console.log(e)
        }
    }

    /**
     * Requête ajax au webservice permettant de récupérer les information sur le produit en fonction de la clé
     * Type de retour :
     *  "product": {
     *  "code": "U",
     *  "version": "260",
     *  "lang": "FR"
     * }
     */
    async ajaxGetProductInfo () {

        if(this.serialInput.value !== "" && this.vCodeInput.value !== "") {

            const data = new FormData()

            data.set('TYPE', 'get_product_info') // Historique
            data.set('FORM', 'DOWNLOAD') // Historique
            data.set('LANGUE', this.language.value)
            data.set('SERIAL', this.serialInput.value)
            data.set('VCODE', this.vCodeInput.value)

            const response = await axios.post('/pcsoft-download/ajax-get-product-info', data)
            return response.data
        }
    }

    /**
     * Retourne un boolean indiquant si les champs permettent de dégriser les boutons de téléchargement
     *
     * @param   productVersion
     * @param   vCode
     * @param   enableCallback
     * @param   disableCallback
     * @returns {*}
     */
    toggleButtons (productVersion, vCode, enableCallback, disableCallback) {
        // Si la clé d'activation n'est pas vide et que le web service retourne un produit
        // sur la clé produit, alors on active les boutons de téléchargement
        // sinon, on les désactive
        (vCode && productVersion)
            ? enableCallback()
            : disableCallback()
    }

    /**
     * Active les boutons de téléchargement du formulaire
     */
    enableButtons () {
        this.buttonLastVersion.removeAttribute('disabled');
        this.buttonOtherVersion.removeAttribute('disabled');
    }

    /**
     * Désactive les boutons de téléchargement du formulaire
     */
    disableButtons () {
        this.buttonLastVersion.value = this.text.lastVersionDefaultText
        this.buttonLastVersion.style.display = "block" // Affiche le bouton

        this.buttonLastVersion.setAttribute('disabled', 'disabled');
        this.buttonOtherVersion.setAttribute('disabled', 'disabled');
    }
}
